module.exports = __webpack_public_path__ + "static/media/Feed.78d9ea61.svg";